<template>
  <v-list-group v-model="expanded">
    <template #activator="{ props }">
      <!-- Activador sin <v-list-item-title> adicional -->
      <v-list-item v-bind="props" prepend-icon="mdi-folder">
        {{ shortTitle }}
      </v-list-item>
    </template>

    <!-- Documentos de la carpeta -->
    <template v-if="folder.docs && folder.docs.length">
      <v-list-item
        v-for="(doc, idx) in folder.docs"
        :key="'doc-' + idx"
        :prepend-icon="doc.type === 'mp4' ? 'mdi-play' : 'mdi-file-document'"
        @click="$emit('select-doc', doc)"
      >
        <v-list-item-title class="file-title">{{
          doc.title
        }}</v-list-item-title>
      </v-list-item>
    </template>

    <!-- Subcarpetas (llamada recursiva) -->
    <template v-if="folder.children && folder.children.length">
      <FolderItem
        v-for="(child, idx) in folder.children"
        :key="'child-' + idx"
        :folder="child"
        :rail="rail"
        :parentTitle="shortTitle"
        @select-doc="$emit('select-doc', $event)"
      />
    </template>
  </v-list-group>
</template>

<script>
export default {
  name: "FolderItem",
  props: {
    folder: { type: Object, required: true },
    rail: { type: Boolean, default: false },
    parentTitle: { type: String, default: "" },
  },
  data() {
    return {
      expanded: this.folder.children && this.folder.children.length > 0,
    };
  },
  computed: {
    shortTitle() {
      let title = this.folder.title || "";
      // Elimina el prefijo si coincide con el parentTitle
      if (this.parentTitle && title.startsWith(this.parentTitle)) {
        title = title.slice(this.parentTitle.length);
        if (title.startsWith("/")) {
          title = title.slice(1);
        }
      }
      // Toma la última parte si hay slashes
      if (title.includes("/")) {
        const parts = title.split("/");
        return parts[parts.length - 1];
      }
      return title;
    },
  },
  mounted() {
    console.log(
      "Renderizando carpeta:",
      this.folder.title,
      "->",
      this.shortTitle
    );
  },
};
</script>

<style scoped>
.file-title {
  white-space: normal;
  word-break: break-word;
}
</style>
